// check if profile store is available
const profileStoreIsAvailable = window.ef.profileStore !== undefined;

export default profileStoreIsAvailable;
